
import {
  Component, PropSync, Ref, Mixins, Watch,
} from 'vue-property-decorator';
import { VForm } from '@/features/common/types';
import { addUser, AddUserDTO } from '@/features/users/services/users.services';
import { emailRules, requiredRules } from '@/features/common/helpers/validationRules';
import { showErrorAlertDialog } from '@/features/common/helpers';
import focusMixin from '@/features/common/mixins/focusMixin';
import AccountSpecification from './AccountSpecification.vue';

@Component({
  components: {
    AccountSpecification,
  },
})
export default class AddUserModal extends Mixins(focusMixin) {
  @Ref('addUsersForm') form!: VForm;

  @PropSync('show', { required: true }) syncedShow!: boolean;

  @Watch('syncedShow')
  onDialogToggle(isOpen: boolean) {
    if (!isOpen) {
      this.resetForm();
    }
  }

  // private timezones = [
  //   'Newfoundland Standard Timezone',
  //   'Atlantic Standard Timezone',
  //   'Eastern Standard Timezone',
  //   'Central Standard Timezone',
  //   'Mountain Standard Timezone',
  //   'Pacific Standard Timezone',
  //   'Alaskan Standard Timezone',
  //   'Hawaiian Standard Timezone',
  // ]

  private isLoading = false;

  private activateValidation = false;

  private requiredRules = requiredRules;

  private emailRules = emailRules;

  private emailInput = '';

  private data: Omit<AddUserDTO, 'username'> = {
    firstName: '',
    lastName: '',
    disabled: false,
    permissions: {
      adminAccess: false,
      viewInvoices: false,
      sharedHistory: false,
    },
    askUserForDefaultAddress: false,
  };

  private async submit(): Promise<void> {
    this.activateValidation = true;
    await this.$nextTick();
    const isValid = this.form.validate();
    if (!isValid) return;

    this.isLoading = true;
    const response = await addUser({
      ...this.data,
      username: this.emailInput,
    });
    this.isLoading = false;

    if (!response.successful) {
      const errorMessage = response.errorMessage
        || this.$t('alertDialog.somethingWentWrong') as string;
      showErrorAlertDialog(errorMessage);
      return;
    }

    this.$emit('add', response.user);
    this.syncedShow = false;
  }

  private resetForm() {
    this.activateValidation = false;
    this.data = {
      firstName: '',
      lastName: '',
      disabled: false,
      permissions: {
        adminAccess: false,
        viewInvoices: false,
        sharedHistory: false,
      },
      askUserForDefaultAddress: false,
    };
    this.emailInput = '';
    (this.$refs.addUsersForm as HTMLFormElement).resetValidation();
    this.syncedShow = false;
  }
}
